module.exports = __webpack_public_path__ + "static/media/1011771.e930e92e.png";